import { Injectable } from '@angular/core';
import { ServiceUtil } from '../utilities/service.util';
import { User } from '../models/user.model';
import { SgPortalDataApiServiceUtil } from '../utilities/sgportal-data-api.service.util';
import { EmployeeModel } from '../models/sgportal-data-api-models/employee.model';
import { Client } from '../models/client.model';
import { ClientApplication } from '../models/client-application.model';
import { Corporation } from '../models/corporation.model';
import {  Observable } from 'rxjs';
import DevExpress from 'devextreme/bundles/dx.all';
import { AspDataStoreService } from './asp-data-store.service';

export class ClientWithApplications {
	constructor(
		public client: Client = new Client(),
		public clientApplications: ClientApplication[] = []
	) 	{}
}

export class ClientToOrganization {
	constructor(
		public clientId: number,
		public organizationId: number
	) {}
}

export class ClientWithIndex {
	constructor(
		public client: Client,
		public index: number
	) {}
}

@Injectable()
export class UserAdminService {
	_controllerName: string = 'Users';
	_sgPortalcontrollerName: string = 'Employee';
	public SelectedCorporationId: number;
    public SelectedCorporation: Corporation;
    public SelectedUserCorporation: Corporation;
	formStatus: string;
	selectedUser: User;
	errorMessages: string[] = [];

	public ClientWithApplications = new ClientWithApplications();
	public ClientsWithApplications = new Array<ClientWithApplications>();
	public ClientsToOrganizations = new Array<ClientToOrganization>();
	public UserEmployees = new Array<EmployeeModel>();
	public UserClients = new Array<ClientWithIndex>();
	public isSubmitted = false;
	public confirmSaving = false;

	constructor
		(private _serviceUtil: ServiceUtil,
			private _sgPortalUtil: SgPortalDataApiServiceUtil,
			private _aspDataStoreService: AspDataStoreService
		) { }

	getUsersForCorporation(corporationId: number, applicationAbbreviation: string, filterByCurrentApplication: boolean): Observable<DevExpress.data.CustomStore> {
		const url = `${this._serviceUtil.webApiServer}/Users/GetUsersForCorporation/${corporationId}/${applicationAbbreviation}/${filterByCurrentApplication}`;		
		return this._aspDataStoreService.getAspDataStoreWithToken(url);
	}

	public ClientIdToOrganizationId(clientId: number): number {
		var returnOrganizationId = -1;
		if (this.ClientsToOrganizations &&
				this.ClientsToOrganizations.length > 0 &&
				this.ClientsToOrganizations.findIndex(x => x.clientId === clientId) > -1)  {
			returnOrganizationId = this.ClientsToOrganizations.find(x => x.clientId === clientId).organizationId;
		}
		return returnOrganizationId;
	}

	public OrganizationIdToClientId(organizationId: number): number {
		var returnClientId = -1;
		if (this.ClientsToOrganizations &&
				this.ClientsToOrganizations.length > 0 &&
				this.ClientsToOrganizations.findIndex(x => x.organizationId === organizationId) > -1)  {
					returnClientId = this.ClientsToOrganizations.find(x => x.organizationId === organizationId).clientId;
		}
		return returnClientId;
	}

	async upsert(updateUserRequest: any): Promise<any> {
		const user = await this._serviceUtil.doPostRequestAsync<any, any>(this._controllerName, 'UpsertUser', updateUserRequest);

		return user;
	}

	async updateUserProfile(updateUserRequest: User): Promise<any> {
		const user = await this._serviceUtil.doPostRequestAsync<any, any>(this._controllerName, 'UpdateUserProfile/false', updateUserRequest);
		return user;
	}

	async enableUser(userId: number): Promise<any> {
		const user = await this._serviceUtil.doPostRequestAsync<any, any>(this._controllerName, `EnableUser/${userId}`, null);
		return user;
	}

  createNew(): any {
			return new User();
	}

	async  createNewUser(newUserRequest: User): Promise<any> {
		const user = await this._serviceUtil.doPostRequestAsync<any, any>(this._controllerName, 'CreateUser/false', newUserRequest);
		return user;
	}

	async  SaveEmployee2(newEmpRequest: EmployeeModel): Promise<EmployeeModel> {
		const user = await this._sgPortalUtil.doPostRequestAsync<any, EmployeeModel>(this._sgPortalcontrollerName, 'SaveEmployee2', newEmpRequest);
		return user;
	}

	async GetEmployee(employeeId: number, organizationId: number) {
		const emp = await this._sgPortalUtil.doGetRequestAsync<EmployeeModel>(this._sgPortalcontrollerName, `GetEmployee/${employeeId}/${organizationId}` );
		return emp;
	}

	async GetEmployeesByEmail(email: string): Promise<EmployeeModel[]>  {
		const emps = await this._sgPortalUtil.doGetRequestAsync<EmployeeModel[]>(this._sgPortalcontrollerName, `GetEmployeesByEmail/${email}`);
		return emps;
	}

	async handleUserArchive(employeeId: number, isArchived: boolean) {
		await this._serviceUtil.doPostRequestAsync('Studer', `HandleStuderUserActiveStatus/${employeeId}/${isArchived}`, null);
	}

	async isUserSGPortalAdmin(): Promise<boolean> {
		let isUserSGAdmin = await this._serviceUtil.doGetRequestAsync<boolean>('Studer', 'IsUserSGPortalAdmin').catch(err => isUserSGAdmin = false);
		return isUserSGAdmin;
	}

	async getAsUserModel(userId: number): Promise<User> {
		return this._serviceUtil.doGetRequestAsync<User>(this._controllerName, `GetAsUserModel/${userId}`);
	}

	async getEditableUserRoles(): Promise<any> {
		return this._serviceUtil.doGetRequestAsync<User>(this._controllerName, 'GetEditableUserRoles');
	}
}
